<template>
  <div class="col mb-2">
    <nav class="container-fluid" role="navigation" aria-labelledby="project-breadcrumb-intro">

      <ol v-if="(selectedProjectId != undefined) && (userProjects !== undefined)" class="breadcrumb mb-0">
        <li class="breadcrumb-item" v-on:click="$emit('unselect-project' )">Projects</li>
        <li class="breadcrumb-item dropdown">
          <span class="dropdown-toggle clickable" data-toggle="dropdown">{{ projectSelected.name }}</span>
          <ul class="dropdown-menu dropdown-menu-left normal-font" aria-labelledby="dropdownMenu1">
            <li v-for="project in userProjects" v-bind:key="project.id"
                v-on:click="$emit('select-project',project )">
              <span class="dropdown-item"
                    :class="{'active': project.id === projectIdToSelect}">{{ project.name }}</span></li>
          </ul>
        </li>
        <li class="breadcrumb-item" aria-current="location">
          <span class="clickable" v-on:click="$emit('select-project', projectSelected )">Collections</span>
        </li>
        <li class="breadcrumb-item">
          <div  title="Select filters" id="collectionsFiltersSelector"
                class="text-nowrap align-items-center position-relative  "
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <span class="icon icon-filter mx-auto my-auto"></span>
            <span class="pb-1  align-middle my-auto ml-1 mr-2 pr-2 pl-1 pt-0">{{ iconFilterText }}</span>
          </div>
          <ul class="dropdown dropdown-menu dropdown-menu-left dropdown-menu-bottom mt-0 mb-1" role="menu"
              aria-labelledby="collectionsFiltersSelector" id="collectionsFiltersCollapse">
            <div class="px-1 py-1">
              <div data-target="collectionsFiltersCollapse"
                   class="custom-control custom-checkbox secondary my-1 black-and-white-checkbox"
                   onClick="document.getElementById('allFilter').click(); event.stopPropagation();">
                <input type="checkbox" class="custom-control-input" id="allFilter" v-on:click="toggleAllFilter($event)"
                       :checked="isAllCollectionSelected">
                <label class="custom-control-label ml-1" for="allFilter"><small>All</small></label>
              </div>
              <div class="dropdown-divider"></div>
              <div v-for="possibleStatusFilter in tableCollections" :key="'dropdown-filter-div-'+possibleStatusFilter"
                   data-target="collectionsFiltersCollapse"
                   class="custom-control custom-checkbox my-1 black-and-white-checkbox"
                   v-on:click="onCheckboxDivClicked($event, possibleStatusFilter)" :style="{'width': '16rem'}">
                <input type="checkbox" class="custom-control-input" :id="'checkbox-'+possibleStatusFilter"
                       v-on:click="toggleFilter(possibleStatusFilter)"
                       :checked="selectedFilters.includes(possibleStatusFilter)">
                <label class="custom-control-label ml-1"
                       :for="'checkbox-'+possibleStatusFilter"><small>{{ possibleStatusFilter }}</small></label>
              </div>
              <div class="dropdown-divider d-none"></div>
              <li href="#" class="dropdown-item btn btn-sm d-none" v-on:click="applyFilters($event)" :active="false">
                Apply filter
              </li>
            </div>
          </ul>
        </li>
        <li class="breadcrumb-item" aria-current="location">
          <span class="clickable" v-on:click="$emit('select-project', projectSelected )">Tables</span>
        </li>
        <li v-if="table !== undefined" class="breadcrumb-item">
          <span class="clickable">{{ table.name }}</span>
          <span v-if="isDownloadButtonDisplayed" class="btn btn-sm btn-secondary ml-1 p-0 pl-1 pr-1 border-1"
                aria-disabled="true"
                :title="(isFileExistingOnServer) ? 'Download' : 'Download not possible: File not found!'"
                :class="{'disabled': !isFileExistingOnServer}"
                :style="{'cursor': (isFileExistingOnServer) ? '' : 'not-allowed'}">
            <span class="icon icon-download align-middle mr-0" :style="{'font-size': iconDownloadFontSize}"></span>
          </span>
        </li>
      </ol>

      <ol v-if="( selectedProjectId === undefined ) && (userProjects !== undefined)" class="breadcrumb mb-0">
        <li class="breadcrumb-item" v-on:click="$emit('unselect-project' )">Projects</li>

      </ol>

      <ol v-if="userProjects === undefined" class="breadcrumb mb-0">
        <li class="breadcrumb-item">Projects</li>
        <li class="breadcrumb-item">
          <span class="d-none d-md-inline-block">Loading</span>
          <span class="spinner spinner--loading"></span>
        </li>

      </ol>

    </nav>
  </div>
</template>

<script>
export default {
  name: "ProjectsNavigationBar",
  props: ["userProjects", "table", "selectedProjectId", "tableCollections"],
  data() {
    return {
      isDownloadButtonDisplayed: false,
      isFileExistingOnServer: true,
      selectedFilters: this.tableCollections,
      isAllCollectionSelected: true

    }
  },
  mounted() {
    console.log('tableCollections: ' + this.tableCollections)
    },
  watch: {
    tableCollections(val, oldVal) {
      console.log(`[watch] [tableCollections] update ${(val && oldVal) ? '' : 'with missing value'}`);
      console.log('tableCollections: ' + this.tableCollections)
      this.toggleAllFilter()
      this.toggleAllFilter()
    },
  },

  computed: {
    iconDownloadFontSize: function () {
      return '1rem';
    },
    projectIdToSelect: function () {
      return (this.selectedProjectId !== undefined) ? this.selectedProjectId : this.userProjects[0].id;
    },
    projectSelected: function () {
      return this.userProjects.filter(userProject => userProject.id === this.projectIdToSelect)[0];
    },
    iconFilterText: function () {
      const numberOfPossibleStatusFilters = this.tableCollections.length;
      const numberOfSelectedFilters = this.selectedFilters.length;
      if (numberOfPossibleStatusFilters === numberOfSelectedFilters) {
        return 'All';
      } else {
        return (numberOfPossibleStatusFilters - numberOfSelectedFilters);
      }
    }
  },
  methods: {
    emitCollectionFilterChange: function () {
      console.log('[emitCollectionFilterChange] ' + this.selectedFilters)
      this.$emit('collection-filter-change', this.selectedFilters);
    },
    applyFilters: function () {
      console.log('[applyFilters] ' + this.selectedFilters)

    },
    toggleAllFilter: function () {

      if (this.isAllCollectionSelected === true) {
        this.selectedFilters = [];
        this.isAllCollectionSelected = false;
      } else {
        this.selectedFilters = this.tableCollections;
        this.isAllCollectionSelected = true;
      }
      console.log('[toggleAllFilter] ' + this.selectedFilters + ' this.isAllCollectionSelected= ' + this.isAllCollectionSelected)
      this.emitCollectionFilterChange();

    },
    toggleFilter: function (filterName) {

      if (this.selectedFilters.includes(filterName)) {
        if (this.isAllCollectionSelected === true) {
          this.isAllCollectionSelected = undefined;
          document.getElementById('allFilter').indeterminate = true;
        }
        this.selectedFilters = this.selectedFilters.filter(elem => elem !== filterName);
        if (this.selectedFilters.length === 0) {
          this.isAllCollectionSelected = false;
          document.getElementById('allFilter').indeterminate = false;
        }
      } else {
        if (this.isAllCollectionSelected === false) {
          this.isAllCollectionSelected = undefined;
          document.getElementById('allFilter').indeterminate = true;
        }
        this.selectedFilters.push(filterName);
        if (this.selectedFilters.length === this.tableCollections.length) {
          this.isAllCollectionSelected = true;
          document.getElementById('allFilter').indeterminate = false;
        }
      }
      console.log('[toggleFilter] ' + this.selectedFilters + ' this.isAllCollectionSelected= ' + this.isAllCollectionSelected)

    },
  onCheckboxDivClicked: function(event, filterName) {

    document.getElementById('checkbox-'+filterName).click();
    event.stopPropagation();
    console.log('[onCheckboxDivClicked] ' + this.selectedFilters + ' this.isAllCollectionSelected= ' + this.isAllCollectionSelected)
    this.emitCollectionFilterChange();


  },
  }
}
</script>
<style scoped>

.clickable {
  cursor: pointer
}

.normal-font {
  font-size: 0.9rem
}

.spinner {
  position: relative;
  padding: 0px 16px;
  background: #ffffff;
  border: none;
  outline: none;
  border-radius: 2px;
}


.spinner--loading::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #000000;
  border-radius: 50%;
  animation: spinner-loading-spinner 1s ease infinite;
}

@keyframes spinner-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.black-and-white-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: black;
}

.black-and-white-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: rgb(204, 204, 204);
  background-color: white;
}

.black-and-white-checkbox .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  /*
    color: yellow;
  */
  background-color: white;
  border-color: rgb(204, 204, 204);
}

.black-and-white-checkbox .custom-control-input ~ .custom-control-label::before {
  /*
    border-color: blue;
  */
  color: rgb(204, 204, 204);
  background-color: rgb(204, 204, 204);
}
</style>